import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useApp } from '../../context/AppContext'
import './Auth.css'

export default function Register() {
  const { signUp } = useApp()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (password !== confirmPassword) {
      return setError('Parolele nu coincid.')
    }
    setLoading(true)
    const { error } = await signUp(email, password)
    setLoading(false)
    if (error) return setError(error.message)
    navigate('/onboarding')
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">STOP <span>PACANELE</span></div>
        <h1>Creeaza cont</h1>
        <p className="auth-sub">Primul pas spre libertate. Anonim, simplu, rapid.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="field">
            <label>Email</label>
            <input
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="email@exemplu.com"
              required
            />
          </div>
          <div className="field">
            <label>Parola</label>
            <input
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Minim 8 caractere"
              minLength={8}
              required
            />
          </div>
          <div className="field">
            <label>Confirma parola</label>
            <input
              type="password" value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Repeta parola"
              minLength={8}
              required
            />
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" className="btn-primary btn-full" disabled={loading}>
            {loading ? 'Se creeaza contul...' : 'Creeaza cont gratuit'}
          </button>
        </form>

        <p className="auth-switch">
          Ai deja cont? <Link to="/login">Autentifica-te</Link>
        </p>

        <p className="auth-disclaimer">
          Prin inregistrare esti de acord cu termenii nostri. Nu stocam date personale identificabile.
        </p>
      </div>
    </div>
  )
}
